'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeIdFromIrisContent = exports.themer = exports.SelectedThemeProvider = exports.ThemeProvider = undefined;

var _ThemeProvider = require('./ThemeProvider');

var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);

var _SelectedThemeProvider = require('./SelectedThemeProvider');

var _SelectedThemeProvider2 = _interopRequireDefault(_SelectedThemeProvider);

var _themer = require('./themer');

var _themer2 = _interopRequireDefault(_themer);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ThemeProvider = _ThemeProvider2.default;
exports.SelectedThemeProvider = _SelectedThemeProvider2.default;
exports.themer = _themer2.default;
exports.getThemeIdFromIrisContent = _util.getThemeIdFromIrisContent;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/theme-provider/lib/cjs/index.js
 ** module id = 9
 ** module chunks = 0
 **/